import axiosInstance from "../axiosHelper/interceptor";
const useWellAnalysis = () => {
    const createGetChartEndpoint = (studyUuid, wellApi, isCumulative, isOverlaid) => {
        const endpoint = isCumulative ? "cumulative-production" : "daily-production";
        const overlaid = isOverlaid ? "/overlaid" : "";
        return `/api/studies/${studyUuid}/api/${wellApi}/${endpoint}${overlaid}`;
    };
    const getWellAnalysis = async (studyUuid, wellApi) => {
        const getEndpoint = `/api/studies/${studyUuid}/api/${wellApi}`;
        try {
            const response = await axiosInstance.get(getEndpoint);
            return response.data;
        }
        catch (error) {
            console.error("Error getting well analysis: ", error);
            return null;
        }
    };
    const fetchChartData = async (studyUuid, wellApi, isCumulative, isOverlaid) => {
        const getEndpoint = createGetChartEndpoint(studyUuid, wellApi, isCumulative, isOverlaid);
        try {
            const response = await axiosInstance.get(getEndpoint);
            return response.data;
        }
        catch (error) {
            console.error("Error getting chart data: ", error);
            return { series: [], xAxis: [], yAxis: [] };
        }
    };
    return {
        getWellAnalysis,
        fetchChartData,
    };
};
export default useWellAnalysis;
